export default __webpack_public_path__ + "static/dummyOne-114686c7e92260cdf787b6407370e7dc.jpg";